'use client'

import { useBreakpoints } from '@/components/providers/BreakpointProvider'
import { type FloatingHoverType } from '@/defs/floating'

import { FloatingModalTrigger } from '../common/FloatingModalTrigger/FloatingModalTrigger'

import { FloatingHoverDesktop } from './FloatingHoverDesktop/FloatingHoverDesktop'

export const FloatingHover = (props: FloatingHoverType) => {
  const { isDesktop } = useBreakpoints()

  if (!props.content) return props.children

  if (!isDesktop) return <FloatingModalTrigger {...props} />

  return <FloatingHoverDesktop {...props} />
}
